module.exports = __webpack_public_path__ + "img/图片15.bb6e66ad.png";